import api from '../../utils/api';
import { alertError, alertSuccess } from './alert';
import { setRolesUpdateRole } from './roles';
import { RETAILER } from '../../constants/roles';
import { signInFlow } from '../actions/auth';

let cancelPostNewRetailer;
export const postNewRetailer = (data) => async (dispatch) => {
  if (cancelPostNewRetailer) {
    cancelPostNewRetailer('Cancel post new retailer');
  }

  try {
    const response = await api.post('/retailers', data, {
      cancelToken: new api.CancelToken((c) => (cancelPostNewRetailer = c)),
    });

    if (response) {
      dispatch(setRolesUpdateRole(response.data.id, RETAILER));
      dispatch(alertSuccess('Successfully created new retailer'));
      dispatch(signInFlow());
    } else {
      dispatch(alertError('Error'));
    }
  } catch (error) {
    dispatch(alertError(error));
  }
};
